<template>
  <div>
    <FlightFilters
      v-if="Object.keys(filterOptions).length > 0"
      :config="filterConfig"
      @updateSort="(order) => (sortOrder = order)"
    />
    <!-- INFO ICONS -->
    <div class="mt-5 mb-2 pb-1 is-flex is-justify-content-center">
      <span class="ml-2 mr-2">
        <b-icon icon="currency-usd" size="is-small" type="is-info"></b-icon>
        <span class="is-size-7 has-text-grey" style="margin-left: -5px;">
          = Unused Ticket Available</span
        >
      </span>
      <span class="ml-2 mr-2" v-if="isOneWay">
        <b-icon
          icon="alpha-f-circle"
          size="is-default"
          class="has-text-grey-lighter"
        />
        <span class="is-size-7 has-text-grey">Fare Rules</span>
      </span>
    </div>

    <!--  HEADERS -->
    <div
      class="columns is-mobile is-gapless mb-0 pr-1 filters-container is-hidden-touch"
    >
      <!-- AIRLINE LOGO -->
      <div class="column is-narrow has-text-centered wrap">
        <div class="mt-1 airlineLogo"></div>
      </div>
      <!-- FROM-TO -->
      <div class="column is-narrow" style="width:150px">
        <span class="sbs-table-header">From-To</span>
      </div>
      <!-- DEPARTURE-ARRIVAl -->
      <div class="column is-narrow" style="width:200px">
        <span class="sbs-table-header">Departure-Arrival</span>
      </div>
      <!-- DURATION -->
      <div class="column">
        <span class="sbs-table-header">Duration & Stops</span>
      </div>
      <!-- UNUSED TICKET -->
      <div class="column has-text-centered is-narrow" style="width:40px;">
        <span class="sbs-table-header" v-if="$globals.ticketAirlines.length > 0"
          >$</span
        >
      </div>
      <!-- OUT OF POLICY -->
      <!-- <div class="column has-text-centered is-narrow" style="width:80px;">
        <span class="sbs-table-header"> Travel Policy </span>
      </div> -->
      <!-- PRICE RANGE -->
      <div
        class="column is-narrow mr-4 price-range"
        :class="
          isOneWay || useAtcShopper ? 'has-text-right' : 'has-text-centered'
        "
        :style="isOneWay || useAtcShopper ? 'width:80px;' : 'width:120px;'"
      >
        <span v-if="useAtcShopper" class="sbs-table-header ml-3 has-text-right"
          >Total Due</span
        >
        <span v-else class="sbs-table-header ml-3">Price</span>
      </div>
      <!-- RESIDUAL VALUE -->
      <div v-if="useAtcShopper" class="column is-narrow mr-2 residual-value">
        <span class="sbs-table-header">Residual Value</span>
      </div>
      <!-- FARE RULES (One-Way Only) -->
      <div
        class="column is-narrow has-text-left"
        v-if="isOneWay"
        style="width:40px;"
      >
        <span class="sbs-table-header">
          Fare
        </span>
      </div>
      <!-- FLIGHT INFO -->
      <div class="column is-narrow" style="width: 100px;"></div>
      <!-- SELECT/DESELECT BUTTONS -->
      <div class="column is-narrow mr-2" style="width: 70px;"></div>
    </div>

    <FilterWarningNotification v-if="showFilterWarning" />

    <div v-if="loading" class="py-2">
      <ResultSkele v-for="(skeleton, index) in 3" :key="index" />
    </div>
    <div
      v-else
      class="flightResultsContainer"
      data-test="price_results_container"
    >
      <PriceResult
        v-for="item in visibleSortedItems"
        :key="item.recId"
        :searchDetails="searchDetails"
        :preferredVendors="preferredVendors"
        :tripVal="tripVal"
        :solution="item"
        @filter="filterByFlight"
        data-test="search_by_price_item"
      />

      <div class="has-text-centered">
        <b-button
          v-if="numVisibleResults < items.length"
          outlined
          type="is-info"
          size="is-medium"
          class="mt-4 mb-4 air_show_more_results_btn"
          @click="numVisibleResults += pageSize"
          >Show more results</b-button
        >
      </div>

      <!-- MORE RESULTS LOADER BELOW -->
      <MoreFlightResultsLoader
        :filterOptions="moreResultsFilterOptions"
        @searchTargetedAirlines="searchTargetedAirlines"
      />
      <!-- END MORE RESULTS LOADER -->
    </div>
  </div>
</template>

<script>
import bookingMixin from "@/mixins/bookingMixin"
import meetingMixin from "@/mixins/meetingsMixin"
import PriceResult from "@/components/BookTravel/Air/PriceResult"
import FlightFilters from "@/components/Filters/FlightFilters.vue"
import MoreFlightResultsLoader from "@/components/BookTravel/Air/MoreFlightResultsLoader"
import ResultSkele from "@/components/SkeletonLoaders/ResultSkele.vue"
import FilterWarningNotification from "./FilterWarningNotification.vue"
import { mapState } from "vuex"

export default {
  name: "ResultsByPrice",
  mixins: [bookingMixin, meetingMixin],
  props: {
    items: Array,
    formData: Object,
    cacheKey: String,
  },
  components: {
    PriceResult,
    FlightFilters,
    ResultSkele,
    MoreFlightResultsLoader,
    FilterWarningNotification,
  },
  data: function() {
    return {
      numVisibleResults: 20,
      pageSize: 20,
      no_results: false,
      policyOnly: false,
      display_search: false,
      results_loaded: 200,
      flightNum: false,
      searchDetails: null,
      sortOrder: "Rating",
    }
  },

  computed: {
    ...mapState(["bookTravel"]),
    ...mapState(["travellersAndTrips"]),
    filters() {
      return this.$store.state.flight.filters
    },
    filterConfig() {
      return {
        filterOptions: this.filterOptions,
        preferredVendors: this.preferredVendors,
        sortOptions: this.sortOptions,
        sortOrder: this.sortOrder,
        unusedTickets: this.unusedTickets,
        tripVal: this.tripVal,
      }
    },
    filterOptions() {
      return this.$store.state.flight.filterOptions
    },
    sortOptions() {
      let options = []
      if (this.tripVal == "0") {
        options = [
          { value: "Rating", label: "Rating" },
          {
            value: "Time of day - Outbound",
            label: "Departure Time (outbound)",
          },
          { value: "Price Asc", label: "Price (Low to High)" },
          { value: "Price Desc", label: "Price (High to Low)" },
          { value: "Duration", label: "Duration" },
        ]
      } else if (this.tripVal == "1") {
        options = [
          { value: "Rating", label: "Rating" },
          {
            value: "Time of day - Outbound",
            label: "Departure Time (outbound)",
          },
          { value: "Time of day - Return", label: "Departure Time (return)" },
          { value: "Price Asc", label: "Price (Low to High)" },
          { value: "Price Desc", label: "Price (High to Low)" },
          { value: "Duration", label: "Duration" },
        ]
      } else {
        options = [
          { value: "Rating", label: "Rating" },
          { value: "Price Asc", label: "Price (Low to High)" },
          { value: "Price Desc", label: "Price (High to Low)" },
          { value: "Duration", label: "Duration" },
        ]
      }

      if (this.preferredVendors.length > 0) {
        options.push({
          value: "Preferred Vendors",
          label: "Preferred Airlines",
        })
      }

      if (this.$store.state.flight.recommendedItems.length > 0) {
        options.push({
          value: "Recommended",
          label: "Recommended",
        })
      }

      return options
    },

    unusedTickets() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ].unusedTicketAirlines
    },
    //filter options for the More Results loader
    moreResultsFilterOptions() {
      const options = {
        allAirlines: this.filterOptions.allAirlines,
        filteredAirlines: this.filterOptions.filteredAirlines,
        unusedTickets: null,
        stops: null,
        tripVal: this.filterOptions.tripVal,
        priceData: null,
        availablePolicies: null,
        highestRating: null,
      }

      return options
    },

    visibleSortedItems() {
      return this.sortedItems.slice(0, this.numVisibleResults)
    },

    sortedItems() {
      const sortedItems = [...this.items]

      if (this.sortOrder === "Rating") {
        sortedItems.sort((a, b) => {
          return b.score - a.score
        })
      } else if (this.sortOrder === "Time of day - Outbound") {
        sortedItems.sort((a, b) => {
          var aDate = new Date(
            a.journeys[0].startDate + " " + a.journeys[0].startTime
          )
          var bDate = new Date(
            b.journeys[0].startDate + " " + b.journeys[0].startTime
          )
          return aDate - bDate
        })
      } else if (this.sortOrder === "Time of day - Return") {
        sortedItems.sort((a, b) => {
          var aDate = new Date(
            a.journeys[1].startDate + " " + a.journeys[1].startTime
          )
          var bDate = new Date(
            b.journeys[1].startDate + " " + b.journeys[1].startTime
          )
          return aDate - bDate
        })
      } else if (this.sortOrder === "Price Asc") {
        sortedItems.sort((a, b) => {
          return a.pricing.total - b.pricing.total
        })
      } else if (this.sortOrder === "Price Desc") {
        sortedItems.sort((a, b) => {
          return b.pricing.total - a.pricing.total
        })
      } else if (this.sortOrder == "Preferred Vendors") {
        sortedItems.sort((a, b) => {
          return this.preferredVendors.includes(a.airlineCode)
            ? -1
            : this.preferredVendors.includes(b.airlineCode)
            ? 1
            : 0
        })
      } else if (this.sortOrder == "Recommended") {
        sortedItems.sort((a, b) => {
          // Check if either item is the selected flight
          const aIsSelected =
            a.uniqueKey === this.$store.state.flight.selectedFlight
          const bIsSelected =
            b.uniqueKey === this.$store.state.flight.selectedFlight

          // If a is selected and b is not, a comes first
          if (aIsSelected && !bIsSelected) {
            return -1
          }
          // If b is selected and a is not, b comes first
          if (!aIsSelected && bIsSelected) {
            return 1
          }

          // Now handle recommendation priority (if neither is selected or both are)
          const aIsRecommended = this.recommendedItems.includes(a.uniqueKey)
          const bIsRecommended = this.recommendedItems.includes(b.uniqueKey)

          if (aIsRecommended && !bIsRecommended) {
            return -1 // a is recommended, b is not, so a comes first
          }
          if (!aIsRecommended && bIsRecommended) {
            return 1 // b is recommended, a is not, so b comes first
          }

          // If items have the same selection and recommendation status,
          // then sort by price
          return a.pricing.total - b.pricing.total
        })
      } else {
        sortedItems.sort((a, b) => {
          // return a.journeys[0].travelDuration - b.journeys[0].travelDuration
          let a_tot = 0
          let b_tot = 0
          for (var i = 0; i < a.journeys.length; i++) {
            a_tot += a.journeys[i].travelDuration
            b_tot += b.journeys[i].travelDuration
          }
          return a_tot - b_tot
        })
      }

      return sortedItems
    },
    recommendedItems() {
      return this.$store.state.flight.recommendedItems
    },
    loading: {
      get() {
        return this.$store.state.bookTravel.searchLoadingStatus
      },
      set(value) {
        this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", value)
      },
    },
    showFilterWarning: {
      get() {
        return this.$store.state.flight.showFilterWarning
      },
      set(value) {
        this.$store.commit("flight/SET_FILTER_WARNING", value)
      },
    },
    startDate() {
      return this.flightDetailsAlt.startDate.date
    },
    endDate() {
      return this.flightDetailsAlt.endDate.date
    },
    startTime() {
      // console.log('checking on startTime', this.flightDetailsAlt.depTime);
      return this.flightDetailsAlt.depTime
    },
    endTime() {
      return this.flightDetailsAlt.arrTime
    },
    tripVal() {
      return this.formData.tripVal
    },
    profile() {
      return this.$store.getters[
        "travellersAndTrips/getCurrentTravellerProfile"
      ]
    },
    preferredVendors() {
      return this.profile.preferredAirVendors || []
    },
    useAtcShopper() {
      return this.$store.state.bookTravel.atc?.useAtcShopper
    },
  },
  methods: {
    filterByFlight(val) {
      this.flightNum = val
      // console.log(this.flightNum)
    },
    searchTargetedAirlines(targetedAirlines) {
      //this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", true);

      //reduce array of objects to simple array of airline codes
      //let targetedAirlines = targetedAirlinesObj.map((a) => a.code);

      this.$emit("searchTargetedAirlines", targetedAirlines)
    },
    loadMore() {
      this.results_loaded += 10
    },

    /*
    addFiltersBasedOnMeetingDates() {
      // tweak this based on new code coming from HuddleLabs
      // console.log('meeting stuff from addFiltersBasedOnMeetingDates', this.meetingInfo);
      // check if flight dates are the same ones that are restricted
      if (
        this.meetingInfo.meeting.latestArrival.date ===
        moment(this.startDate).format("YYYY-MM-DD")
      ) {
        // console.log('arriving on meeting start date');
        if (this.meetingInfo.meeting.latestArrival.time !== null) {
          // format time
          let formattedTime = this.meetingInfo.meeting.latestArrival.time
          formattedTime = formattedTime.split(":"[0])
          formattedTime = parseInt(formattedTime)
          formattedTime = formattedTime - 1

          this.filters.timeRangeSegment1 = {
            segment: 1,
            range: [0, formattedTime],
          }
        } else {
          this.filters.timeRangeSegment1 = {
            segment: 1,
            range: [0, 24],
          }
        }
      }

      if (
        this.meetingInfo.meeting.earliestDeparture.date ===
        moment(this.endDate).format("YYYY-MM-DD")
      ) {
        // console.log('departing on meeting end date');
        if (this.meetingInfo.meeting.earliestDeparture.time !== null) {
          // format time
          let formattedTime = this.meetingInfo.meeting.earliestDeparture.time
          formattedTime = formattedTime.split(":"[0])
          formattedTime = parseInt(formattedTime)

          this.filters.timeRangeSegment2 = {
            segment: 0,
            range: [formattedTime, 24],
          }
        } else {
          this.filters.timeRangeSegment2 = {
            segment: 0,
            range: [0, 24],
          }
        }
      }
    },
    */
  },
  created() {
    this.TRIP_ONE_WAY = 0
    this.TRIP_ROUNDTRIP = 1
    this.TRIP_MULTI_CITY = 2
    this.ARRIVAL_TIME = 1
    this.DEPARTURE_TIME = 0
  },
  mounted() {
    if (this.$store.state.flight.recommendedItems.length > 0) {
      this.sortOrder = "Recommended"
    }
  },
}
</script>

<style lang="scss" scoped>
.scroller {
  height: 100%;
}
.field {
  border-radius: 5px;
  width: 800px;
}
.centered {
  margin: auto auto auto 16rem;
}
.end-divider {
  border: 1px dashed #ddddde;
  margin: 10px 0;
}
</style>
